import React, { useState, useEffect } from 'react';
import './Join.css';
import SwitchLight from '../../assets/images/light/switch-light.png';
import SwitchDark from '../../assets/images/dark/switch-dark.png';
import facehLight from '../../assets/images/light/light-menu.png';
import facehDark from '../../assets/images/dark/dark-menu.png';
import nav from '../../assets/images/nav.png';
import joinButton from '../../assets/images/joinme-btn.png';
import closeButton from '../../assets/images/menu-close.png';
import Navbar from '../navbar/Navbar';

import desktopLight from '../../assets/images/join/join-l.png';
import desktopDark from '../../assets/images/join/join-d.png';
import mobileLight from '../../assets/images/mobile/join/join-l.png';
import mobiledark from '../../assets/images/mobile/join/join-d.png';
const Join = (props) => {
  const [expand, setExpand] = useState(false);

  const [image, setImage] = useState(
    window.innerWidth > 425
      ? props.mod
        ? desktopDark
        : desktopLight
      : props.mod
        ? mobiledark
        : mobileLight
  );

  const setAnimation = (ev) => {
    let el = document.getElementById('foo');
    el.style.height = el.getBoundingClientRect().height + 5 + 'px';
  };

  const checkDrag = (e) => {
    let ds = document.getElementById('foo');

    window.innerWidth > 425
      ? props.mod
        ? (ds.style.top = '-30px')
        : (ds.style.top = '0px')
      : props.mod
        ? (ds.style.top = '-30px')
        : (ds.style.top = '0px');

    if (e >= 380) {
      if (window.innerWidth > 425 && props.mod) {
        setImage(desktopLight);
        props.changeTheme(!props.mod);
      } else if (window.innerWidth > 425 && !props.mod) {
        setImage(desktopDark);
        props.changeTheme(!props.mod);
      } else if (window.innerWidth <= 425 && props.mod) {
        setImage(mobileLight);
        props.changeTheme(!props.mod);
      } else if (window.innerWidth <= 425 && !props.mod) {
        setImage(mobiledark);
        props.changeTheme(!props.mod);
      }
    } else {
      if (window.innerWidth > 425 && props.mod) {
        setImage(desktopLight);
        props.changeTheme(!props.mod);
      } else if (window.innerWidth > 425 && !props.mod) {
        setImage(desktopDark);
        props.changeTheme(!props.mod);
      } else if (window.innerWidth <= 425 && props.mod) {
        setImage(mobileLight);
        props.changeTheme(!props.mod);
      } else if (window.innerWidth <= 425 && !props.mod) {
        setImage(mobiledark);
        props.changeTheme(!props.mod);
      }
    }
  };
  const navAction = () => {
    setExpand(!expand);
  };
  useEffect(() => {
    function chechSize(e) {
      if (window.innerWidth > 425 && props.mod) {
        setImage(desktopDark);
      } else if (window.innerWidth > 425 && !props.mod) {
        setImage(desktopLight);
      } else if (window.innerWidth <= 425 && props.mod) {
        setImage(mobiledark);
      } else if (window.innerWidth <= 425 && !props.mod) {
        setImage(mobileLight);
      }
    }

    window.addEventListener('resize', chechSize);
  });

  return (
    <div className=" w-full h-screen relative flex flex-col overflow-y-hidden overflow-x-hidden">
      <div className=" w-full h-full absolute">
        <img
          src={image}
          className="  z-40  w-full h-full "
          loading="lazy"
        />
      </div>

      <div className=" flex flex-col w-full h-full relative  ">
        <div
          className={`w-full h-auto flex flex-row  justify-between relative `}
        >
          <div
            id="foo"
            className={`flex flex-col w-[178px] z-50  ss ${props.mod
              ? ' xxs:-top-[30px] sm:top-[0px]'
              : 'xxs:-top-[30px] sm:top-[0px]'
              }   xxs:h-[190px]  sm:h-auto xs:-left-10 sm:left-0  relative cursor-move`}
            onClick={(e) => {
              checkDrag(e.clientY);
            }}
          >
            <img
              src={props.mod ? SwitchDark : SwitchLight}
              alt="switch"
              className="w-auto h-full"
            />
          </div>
          <div className="flex flex-col w-fit h-fit  cursor-pointer     relative">
            <img
              src={props.mod ? facehLight : facehDark}
              className={`relative ${expand ? 'event-rm' : 'event-add'
                } navhover xxs:w-[60%] xxs:h-auto sm:w-[65%] xxs:left-12 xs:-top-2  sm:top-7 md:left-9 lg:left-0  sm:h-auto z-[999]  `}
              alt="face"
              onClick={navAction}
            />
          </div>
        </div>
        <div
          className={`w-full   flex-col h-full  z-[999]  top-0 right-0   absolute    backdrop-blur-sm   ${expand ? 'flex' : 'hidden'
            } justify-center items-center`}
        >
          <div className=" flex-row flex  w-full h-fit justify-center items-center  relative z-0 bg-menu mb-20">
            <div className=" flex-row flex  xxs:w-[450px] sm:w-[530px] h-fit justify-center items-center  relative z-0">
              <img
                src={nav}
                alt="nav"
                className="  w-[1050px]  xxs:h-[400px] sm:h-[500px]     absolute    order-2 "
              />
              <img
                src={closeButton}
                alt="closeBtn"
                className="w-[130px] z-40 xxs:-top-10 xs:-top-10 sm:top-1 xxs:right-10 sm:right-16 xxs:h-[180px] sm:h-fit absolute order-1 cursor-pointer close-btn"
                onClick={navAction}
              />
              <div className=" xxs:mt-12 sm:mt-16  relative sm:-left-5">
                <Navbar />
              </div>
            </div>
          </div>
        </div>

        <div className="    absolute w-full h-full flex flex-col">
          <div className="flex flex-col top-[31rem] relative w-full h-full  pl-52  join-container  ">
            <div className=" flex flex-col  w-[70vw] h-auto z-50  relative xxs:-top-[33vh] xxs:-left-36 xs:-top-30  sm:-top-4 md:-left-28 lg:-left-20 sm:w-[250px] lg:w-[350px] 2xl:w-[38%] 2xl:left-0 3xl:left-0 ">
              <input
                type="email"
                className={`w-full h-[60px]    outline-none border-none px-4 font-child text-4xl  relative ${props.mod ? 'text-white' : 'text-black'
                  } font-extrabold bg-transparent`}
              />
            </div>
            <div className="flex flex-col relative w-[60vw] h-full z-50 xxs:-top-[32vh] xxs:-left-20 xs:-top-64 sm:-left-24 sm:top-2 md:-left-32 lg:-left-16 2xl:-left-4 sm:w-[200px] md:w-[250px] 2xl:w-[30%] 3xl:left-56 3xl:top-10">
              <button>
                <img src={joinButton} alt="joinBtn" className="join-btn" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Join;
